// Export types and interfaces
export * from './types';

// Export registry
export {
  DefaultSearchProviderRegistry,
  searchProviderRegistry,
} from './registry';

// Export providers
export { EmailProvider } from './email-provider';
export { SessionActionsProvider } from './session-actions-provider';
export { SessionProvider } from './session-provider';
export { SystemActionsProvider } from './system-actions-provider';

// Export quick actions types and registry
export {
  DefaultQuickActionsProviderRegistry,
  quickActionsProviderRegistry,
} from './quick-actions-registry';
export * from './quick-actions-types';

// Export quick actions providers
export { ClearSearchQuickActionsProvider } from './clear-search-quick-actions-provider';
export { ScreenSharingQuickActionsProvider } from './screen-sharing-quick-actions-provider';
export { SessionQuickActionsProvider } from './session-quick-actions-provider';

// Export icons
export { EndFlikIcon, StartFlikIcon } from './icons';

// Export email utilities
export {
  addRecentEmail,
  getRecentEmails,
  removeRecentEmail,
  validateEmail,
} from './email-utils';

// Initialize and register all default providers
import { ClearSearchQuickActionsProvider } from './clear-search-quick-actions-provider';
import { EmailProvider } from './email-provider';
import { quickActionsProviderRegistry } from './quick-actions-registry';
import { searchProviderRegistry } from './registry';
import { SessionActionsProvider } from './session-actions-provider';
import { SessionProvider } from './session-provider';
import { SystemActionsProvider } from './system-actions-provider';

// Register all default providers
export function initializeDefaultProviders() {
  // Search content providers
  searchProviderRegistry.register(new SystemActionsProvider());
  searchProviderRegistry.register(new SessionActionsProvider());
  searchProviderRegistry.register(new EmailProvider());
  searchProviderRegistry.register(new SessionProvider());

  // Quick actions providers
  // quickActionsProviderRegistry.register(new SessionQuickActionsProvider());
  // quickActionsProviderRegistry.register(
  //   new ScreenSharingQuickActionsProvider(),
  // );
  quickActionsProviderRegistry.register(new ClearSearchQuickActionsProvider());
}
